import { render, staticRenderFns } from "./ReportSubmission.vue?vue&type=template&id=61a64907&scoped=true&"
import script from "./ReportSubmission.vue?vue&type=script&lang=js&"
export * from "./ReportSubmission.vue?vue&type=script&lang=js&"
import style0 from "./ReportSubmission.vue?vue&type=style&index=0&id=61a64907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a64907",
  null
  
)

export default component.exports